<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :search-input.sync="search"
    :label="label"
    :rules="[v => !!v || '']"
    :disabled="readonly"
    :height="height"
    return-object
    hide-details
    browser-autocomplete="nope"
    no-filter
    no-data-text="В справочнике не указанны валюты"
    outline
    prepend-inner-icon="folder_open"
    @change="handleItemChange"
  >
    <template v-slot:prepend-item>
      <slot name="prepend-content">
        <v-layout>
          <v-spacer />
          <v-btn
            small
            @click="createNew"
          >
            Добавить
          </v-btn>
        </v-layout>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { NestedEditorsEventBus } from "../nested-editors/nested-editors-event-bus.js";
export default {
  props: ["value", "label", "disabled", "titleForNestedEditor", "heightItem"],
  data() {
    return {
      selected: null,
      search: null,
      items: [],
      resource: "currencies",
      componentName: "Currency",
      height: null,
    };
  },
  computed: {
    readonly() {
      return this.disabled;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selected = {
            text: val.title,
            value: val.id,
          };
        }
      },
    },
    search() {
      if (!this.search) {
        this.selected = null;
        this.getData();
        return;
      } else {
        if (this.selected && this.selected.text === this.search) {
          return;
        }

        setTimeout(() => {
          if (!this.search) {
            this.selected = null;
            this.items = [];
            return;
          }
          this.$http
            .get(`currencies/referencies?searchTerm=${this.search}`)
            .then((res) => {
              if (Array.isArray(res.data)) {
                this.items = res.data.map((i) => {
                  return {
                    text: i.Title,
                    value: i.Id,
                  };
                });
              } else {
                this.items = [];
              }
            });
        }, 500);
      }
    },
    heightItem: {
      handler(val) {
        if (val) {
          this.height = val;
        } else {
          this.height = 40;
        }
      },
      immediate: true,
    },
  },
  created() {
    NestedEditorsEventBus.$on("create-" + this._uid, (createdId) => {
      this.$http.get(`currencies/referencies/${createdId}`).then((res) => {
        this.setSelectedElement({ id: res.data.Id, title: res.data.Title });
      });
    });
    this.getData();
  },
  methods: {
    handleItemChange() {
      this.$emit(
        "input",
        this.selected
          ? { id: this.selected.value, title: this.selected.text }
          : null,
      );
    },
    getData() {
      this.$http.get("currencies/referencies").then((res) => {
        this.items = res.data.map((i) => {
          return {
            text: i.Title,
            value: i.Id,
          };
        });
        if (!this.value && this.items.length > 0) {
          this.selected = this.items[0];
          this.handleItemChange();
        }
      });
    },
    createNew() {
      const vMenu = this.$children[0].$children.find(
        (c) => c.$options.name === "v-menu",
      );
      if (vMenu) {
        vMenu.$data.isActive = false;
      }
      this.$emit("click");
      NestedEditorsEventBus.$emit("open", {
        title: this.label ? this.label : this.titleForNestedEditor,
        uid: this._uid,
        component: this.componentName,
      });
    },
    setSelectedElement(value) {
      const newItem = {
        value: value.id,
        text: value.title,
      };
      this.items.push(newItem);
      this.selected = newItem;
      this.handleItemChange();
    },
  },
};
</script>
